import { zeroPad } from 'app/components/Song/Audio/AudioTableList/utils';

export const getFormattedDurationForPlaylist = (ms?: number) => {
  if (!ms) return null;
  const hours = Math.floor(ms / 3600000);
  const minutes = Math.floor((ms / 60000) % 60);
  const seconds = Math.floor((ms / 1000) % 60);
  return `${hours === 0 ? '' : `${zeroPad(hours, 2)} hrs `}${zeroPad(
    minutes,
    2
  )} min ${zeroPad(seconds, 2)} sec`;
};

export const getFormattedFilesCount = (count: number) => {
  if (count === 1) {
    return '1 File';
  }
  return `${count} Files`;
};
